// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import { useId } from 'react';
import type { Icon } from 'iconsax-react';

const TrashFieldIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || '#2D0A6C';
  const accent = '#141414';
  const id = useId();
  const clipId = `trash-clip-${id}`;
  const maskId = `trash-mask-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="trash field"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <mask id={maskId} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <path d="M15.5 0.5V15.5H0.5V0.5H15.5Z" fill="white" stroke="white" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path d="M14.0004 4.4873C13.9871 4.4873 13.9671 4.4873 13.9471 4.4873C10.4204 4.13397 6.90042 4.00064 3.41377 4.35397L2.05377 4.4873C1.77377 4.51397 1.5271 4.31397 1.50043 4.03397C1.47377 3.75397 1.67377 3.51397 1.9471 3.4873L3.3071 3.35397C6.85375 2.99397 10.4471 3.13397 14.0471 3.4873C14.3204 3.51397 14.5204 3.76064 14.4938 4.03397C14.4738 4.29397 14.2538 4.4873 14.0004 4.4873Z" fill={fill} />
          <path d="M5.66749 3.8135C5.64082 3.8135 5.61415 3.8135 5.58082 3.80683C5.31415 3.76016 5.12749 3.50016 5.17415 3.2335L5.32082 2.36016C5.42749 1.72016 5.57415 0.833496 7.12748 0.833496H8.87415C10.4341 0.833496 10.5808 1.7535 10.6808 2.36683L10.8275 3.2335C10.8741 3.50683 10.6875 3.76683 10.4208 3.80683C10.1475 3.8535 9.88748 3.66683 9.84748 3.40016L9.70081 2.5335C9.60748 1.9535 9.58748 1.84016 8.88081 1.84016H7.13415C6.42749 1.84016 6.41415 1.9335 6.31415 2.52683L6.16082 3.3935C6.12082 3.64016 5.90749 3.8135 5.66749 3.8135Z" fill={fill} />
          <path d="M10.1406 15.1667H5.86058C3.53392 15.1667 3.44058 13.8801 3.36725 12.8401L2.93392 6.12672C2.91392 5.85338 3.12725 5.61338 3.40058 5.59338C3.68058 5.58005 3.91392 5.78672 3.93392 6.06005L4.36725 12.7734C4.44058 13.7867 4.46725 14.1667 5.86058 14.1667H10.1406C11.5406 14.1667 11.5672 13.7867 11.6339 12.7734L12.0672 6.06005C12.0872 5.78672 12.3273 5.58005 12.6006 5.59338C12.8739 5.61338 13.0872 5.84672 13.0672 6.12672L12.6339 12.8401C12.5606 13.8801 12.4672 15.1667 10.1406 15.1667Z" fill={fill} />
          <path d="M9.10673 11.5H6.88673C6.61339 11.5 6.38672 11.2733 6.38672 11C6.38672 10.7267 6.61339 10.5 6.88673 10.5H9.10673C9.38007 10.5 9.60673 10.7267 9.60673 11C9.60673 11.2733 9.38007 11.5 9.10673 11.5Z" fill={accent} />
          <path d="M9.66732 8.8335H6.33398C6.06065 8.8335 5.83398 8.60683 5.83398 8.3335C5.83398 8.06016 6.06065 7.8335 6.33398 7.8335H9.66732C9.94065 7.8335 10.1673 8.06016 10.1673 8.3335C10.1673 8.60683 9.94065 8.8335 9.66732 8.8335Z" fill={accent} />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { TrashFieldIcon };
